function rawCurrencyFilter() {
    'ngInject';

    return number => number / 100.0;
}

angular
    .module('BB')
    .filter('raw_currency', rawCurrencyFilter);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/raw_currency.filter.js